import React from 'react';
import { Wrench, Gauge, CircleDot, Settings, ClipboardCheck, Cog, Target, Lightbulb, Wind, Battery, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Wrench,
  Gauge,
  CircleDot,
  Settings,
  ClipboardCheck,
  Cog,
  Target,
  Lightbulb,
  Wind,
  Battery
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-slate-200">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Nos Services
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Services Professionnels
            <span className="block text-sky-600 mt-2">pour Votre Véhicule</span>
          </h2>
          <p className="text-lg text-slate-700">
            Une gamme complète de services automobiles réalisés par des professionnels qualifiés
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-gradient-to-br from-slate-100 to-slate-200 rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-slate-300 hover:border-sky-400"
              >
                <div className="bg-gradient-to-br from-sky-100 to-slate-300 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-sm">
                  <IconComponent className="text-sky-600" size={32} />
                </div>
                
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-sky-600 transition-colors">
                  {service.title}
                </h3>
                
                <p className="text-slate-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <button className="text-sky-600 font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
                  En savoir plus
                  <ArrowRight size={18} />
                </button>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-sky-500 to-slate-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Besoin d'un Service Particulier ?
          </h3>
          <p className="text-sky-100 mb-6 max-w-2xl mx-auto">
            Notre équipe est à votre disposition pour répondre à tous vos besoins en matière de mécanique automobile
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="bg-white text-sky-600 px-8 py-3 rounded-lg font-semibold hover:bg-sky-50 transition-all shadow-lg hover:shadow-xl"
          >
            Contactez-nous
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
